import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
//
// ## Description
// A base class for stave modifiers (e.g. clefs, key signatures)
import { Element } from './element';
export var StaveModifier = /*#__PURE__*/function (_Element) {
  _inherits(StaveModifier, _Element);

  _createClass(StaveModifier, null, [{
    key: "Position",
    get: function get() {
      return {
        LEFT: 1,
        RIGHT: 2,
        ABOVE: 3,
        BELOW: 4,
        BEGIN: 5,
        END: 6
      };
    }
  }]);

  function StaveModifier() {
    var _this;

    _classCallCheck(this, StaveModifier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StaveModifier).call(this));

    _this.setAttribute('type', 'StaveModifier');

    _this.padding = 10;
    _this.position = StaveModifier.Position.ABOVE;
    _this.layoutMetrics = null;
    return _this;
  }

  _createClass(StaveModifier, [{
    key: "getPosition",
    value: function getPosition() {
      return this.position;
    }
  }, {
    key: "setPosition",
    value: function setPosition(position) {
      this.position = position;
      return this;
    }
  }, {
    key: "getStave",
    value: function getStave() {
      return this.stave;
    }
  }, {
    key: "setStave",
    value: function setStave(stave) {
      this.stave = stave;
      return this;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.width = width;
      return this;
    }
  }, {
    key: "getX",
    value: function getX() {
      return this.x;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      return this;
    }
  }, {
    key: "getCategory",
    value: function getCategory() {
      return '';
    }
  }, {
    key: "makeSpacer",
    value: function makeSpacer(padding) {
      // TODO(0xfe): Return an instance of type `Spacer` based on `GhostNote`
      // instead of this hack.
      return {
        getContext: function getContext() {
          return true;
        },
        setStave: function setStave() {},
        renderToStave: function renderToStave() {},
        getMetrics: function getMetrics() {
          return {
            width: padding
          };
        }
      };
    }
  }, {
    key: "placeGlyphOnLine",
    value: function placeGlyphOnLine(glyph, stave, line) {
      glyph.setYShift(stave.getYForLine(line) - stave.getYForGlyphs());
    }
  }, {
    key: "getPadding",
    value: function getPadding(index) {
      return index !== undefined && index < 2 ? 0 : this.padding;
    }
  }, {
    key: "setPadding",
    value: function setPadding(padding) {
      this.padding = padding;
      return this;
    }
  }, {
    key: "setLayoutMetrics",
    value: function setLayoutMetrics(layoutMetrics) {
      this.layoutMetrics = layoutMetrics;
      return this;
    }
  }, {
    key: "getLayoutMetrics",
    value: function getLayoutMetrics() {
      return this.layoutMetrics;
    }
  }]);

  return StaveModifier;
}(Element);